import { render, staticRenderFns } from "./setSeriesButtonDialog.vue?vue&type=template&id=128be9bd&"
import script from "./setSeriesButtonDialog.vue?vue&type=script&lang=js&"
export * from "./setSeriesButtonDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports